module.exports = __webpack_public_path__ + "img/arrow-down-icon.b59fd1f8.svg";